import { render, staticRenderFns } from "./MaterialsQuoteStatistics.vue?vue&type=template&id=50e342b6&scoped=true&"
import script from "./MaterialsQuoteStatistics.vue?vue&type=script&lang=js&"
export * from "./MaterialsQuoteStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsQuoteStatistics.vue?vue&type=style&index=0&id=50e342b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e342b6",
  null
  
)

export default component.exports